module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCA4IDgiIGZpbGw9IiNGNkY4RjAiPgogIDxwYXRoIGQ9Ik0yIDB2NWgtMmwzLjAzIDMgMi45Ny0zaC0ydi01aC0yeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiIC8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/down.svg
// module id = 443
// module chunks = 35783957827783